export default __webpack_public_path__ + "static/media/11.15505d4f.jpg";